import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

import { BaseCard } from '../../../components/wizard';

class CloseCard extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;

  render = () => {
    return (
      <Box>
        <BaseCard
          cardid={'CLOSE'}
          cardname={'close'}
          cardtitle={'Completed'}
          instruction={'Member registration process is complete.'}
          step={8}
          buttons={['DONE', 'GUIDE']}
          {...this.props}
        >
          <Typography>
            Member registration has been submitted successfully.
          </Typography>
        </BaseCard>
      </Box>
    );
  };
}

CloseCard.propTypes = {
  classes: PropTypes.object,
};

export default CloseCard;
